<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				员工离职-{{ruleForm.id == null || ruleForm.id == '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->
			<div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
				<!-- 查询框 -->
				<span style="color:#006E4B;font-weight:900;font-size:20px">|</span>
				<span style="font-size:20px;font-weight:700">基本信息</span>
				<div style="border:1px solid #DADADA;margin-top:10px"></div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<div @click="yglz()" v-show="ruleForm.id == null || ruleForm.id === ''" >
								
								<el-form-item label="姓名" prop="staff.staff_name"  style="margin-top:40px;width:80%">
									<el-input v-model="ruleForm.staff.staff_name" placeholder="请输入姓名"></el-input>
								</el-form-item>

							</div>
						</el-col>

						<el-col :span="12">
							<div v-show="ruleForm.id != null && ruleForm.id != '' " >
								
								<el-form-item label="姓名" prop="staff.staff_name" v-show="ruleForm.id != null && ruleForm.id != '' " style="margin-top:40px;width:80%">
									<el-input v-model="ruleForm.staff.staff_name" placeholder="请输入姓名" :disabled="true"></el-input>
								</el-form-item>
			
							</div>
						</el-col>



						<el-col :span="12">
							<el-form-item label="身份证号" style="margin-top:40px;width:80%">
								<el-input v-model="ruleForm.staff.staff_card" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="手机号" style="width:80%">
								<el-input v-model="ruleForm.staff.staff_telephone" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入职日期" style="width:80%">
								<el-input v-model="ruleForm.staff.induction_time" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="组织架构" style="width:80%">
								<el-input v-model="ruleForm.staff.range" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="城市" style="width:80%">
								<el-input v-model="ruleForm.staff.city_id" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="职位" style="width:80%">
								<el-input v-model="ruleForm.staff.post_name" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入职薪酬" style="width:80%" prop="staff.induction_salary">
								<el-input v-model="ruleForm.induction_salary" ></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<div style="margin-top:50px">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">离职信息</span>
						<div style="border:1px solid #DADADA;margin-top:10px"></div>

						<el-row>
							<el-col :span="12">
								<el-form-item label="离职日期" prop="quit_date" style="margin-top:50px">
									<el-date-picker v-model="ruleForm.quit_date" value-format="yyyy-MM-dd" type="date"
										style="width:80%" placeholder="请选择">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="离职原因" prop="dictionaries_id" style="margin-top:50px">
									<el-select v-model="ruleForm.dictionaries_id" style="width:80%" placeholder="请选择"
										clearable>
										<el-option v-for="item in causeList" :key="item.id" :label="item.data"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col>
								<el-form-item label="离职审批表" prop="quit_url">
									<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
									:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
									:on-success="handleAvatarSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="ruleForm.quit_url" alt="">
								</el-dialog>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="离职提交日期">
									<el-date-picker v-model="ruleForm.quit_time" type="date" style="width:80%" disabled="disabled"
										value-format="yyyy-MM-dd" placeholder="请选择">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="操作人"  v-show="ruleForm.id == null || ruleForm.id === '' " >
									<el-select v-model="ruleForm.operator" placeholder="请选择" style="width:80%"
										clearable   v-show="ruleForm.id === null || ruleForm.id === ''"  >
										<el-option v-for="item in userList" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="操作人" style="width:80%"  v-show="ruleForm.id != null && ruleForm.id != '' ">
									<el-input v-model="ruleForm.operator" :disabled="true"></el-input>
								</el-form-item>


							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="备注" prop="remarks">
									<el-input v-model="ruleForm.remarks" placeholder="请输入" style="width:80%">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>

					</div>

					<div style="margin-top:50px" v-show="StaffChuXianJiLu">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">保险信息</span>
						<div style="border:1px solid #DADADA;margin-top:10px"></div>

						<el-row>
							<el-col>
								<el-table :data="StaffChuXian" border style="width: 80%;margin:20px 10%">
									<el-table-column align="center" label="保险类型">{{雇主险}}</el-table-column>
									<el-table-column prop="danger_dete" align="center" label="出险时间"></el-table-column>
									<el-table-column prop="indemnity_amount" align="center" label="赔付金额">
									</el-table-column>
									<el-table-column prop="settlement_status" align="center" label="理赔状态">
										<template slot-scope="scope">
											{{scope.row.settlement_status == '0' ?  '未理赔':
                   							(scope.row.settlement_status == '1' ?  '已理赔' : '已撤案' )  }}
										</template>
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>

					</div>

					<el-form-item style="margin-top:30px; text-align: center;" label-width="0" v-show="ruleForm.id == null || ruleForm.id === '' ">
						<el-button type="goon" @click="Add">保存</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')"   >重置</el-button>
					</el-form-item>
					<el-form-item style="margin-top:30px; text-align: center;" label-width="0" v-show="ruleForm.id != null && ruleForm.id != '' ">
						<el-button type="goon" @click="Add">保存</el-button>
					</el-form-item>

				</el-form>
			</div>
		</div>

		<el-dialog title="员工离职" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="true" @commit="saveChange"
					:staff_id_prop="object.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="4" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->

	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	// import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			// SelectAuditor: SelectAuditor,
		},
		props: ["ruleForm", "organizeList", "causeList", "userList"],
		data() {
			return {
				rules: {
					'staff.staff_name': [{
						required: true,
						message: '请输入姓名！',
						trigger: 'blur'
					}],
					quit_date: [{
						required: true,
						message: '请选择离职日期！',
						trigger: 'blur'
					}],
					dictionaries_id: [{
						required: true,
						message: '请选择离职原因！',
						trigger: 'blur'
					}],
					quit_url: [{
						required: true,
						message: '请提交离职审批表！',
						trigger: 'blur'
					}],
					'staff.induction_salary':[{
						required: true,
						message: '请输入入职薪酬！',
						trigger: 'blur'
					}],
					induction_salary:[{
						required: true,
						message: '请输入入职薪酬！',
						trigger: 'blur'
					}]
				},

				object: {
					staff_id: '',
					staff: '',
					organize_id: '',
					organize_name: '',
				},

				//页面相关
				dialogVisible: false,
				dialogAuditorVisible: false,

				//员工出险记录
				StaffChuXian:[],
				StaffChuXianJiLu:false,

			};
		},
		methods: {
			//离职审批表上传
			handleAvatarSuccess(res, file) {
				this.$props["ruleForm"].quit_url = res.data.fileUrl;
			},
			//选择人员
			yglz() {
				this.dialogVisible = true;
			},
			//点击确定
			saveChange(e) {
				this.$props["ruleForm"].staff_id = e.staff_id;
				this.$props["ruleForm"].staff = e.staff[0];
				this.chuxianjilu(e.staff_id);
				this.dialogVisible = false;
			},

			async chuxianjilu(staff_id){
				this.StaffChuXian=[];
				var url = 'StaffQuit/selectStaffDanger';
				var record = {
					staff_id:staff_id,
					};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length <= 0){
							this.StaffChuXianJiLu=false;
						}else{
							this.StaffChuXian = data;
							this.StaffChuXianJiLu=true;
						}
					}else {
					}
				}


			},

			//选择审批人
			// auditor() {
			// 	this.$refs["ruleForm"].validate((valid) => {
			// 		if (valid) {
			// 			this.$props["ruleForm"].examineDetailsList = [];
			// 			this.dialogAuditorVisible = true;
			// 			this.$refs['SelectAuditor'].initialize();
			// 		} else {
			// 			console.log('error submit!!');
			// 			return false;
			// 		}
			// 	});
			// },


			//添加
			Add() {
				
				var sf = true;
				if( this.$props["ruleForm"].id == null || this.$props["ruleForm"].id == "" ){
					if(this.StaffChuXian.length > 0){
						this.StaffChuXian.forEach(item =>{
							if(item.settlement_status == '0'){
								sf=false;
							}
						})
						if(sf){
							this.insert();
						}else{
							this.$message.warning("当前员工有未理赔的出险记录！不能进行离职操作！");
						}
					}else if(this.ruleForm.induction_salary === '' || this.ruleForm.induction_salary === null){
						this.$message.warning("请选择入职薪酬！");
					}else{
						this.insert();
					}
				}else{
					this.Update();
				}

				
			},

			async insert(){
				var url = 'StaffQuit/insert';
				var record = this.$props['ruleForm'];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},


			//修改
			async Update() {
				var url = 'StaffQuit/update';
				var record = this.$props['ruleForm'];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//重置
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			//返回
			Return() {
				this.dialogAuditorVisible = false;
				this.$emit("return");
				// this.$parent.find()
			},
		},
		created() {},
	};
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Yglz_add.vue?df2e882e